module.exports = __webpack_public_path__ + "img/icon-ai-picker-line@3x.d6d91722.png";